// extracted by mini-css-extract-plugin
export default {"selected":"tab_selected__-BOz5","unselected":"tab_unselected__3LJ07"};